import { useEffect } from 'react';

import hotjar from '@opendoor/shared-fe/build/hotjar';
import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';
import { useObservability } from 'shared/helpers/observability';

/** TODO: Add documentation */
export const useHotjarTrigger = (trigger: string, skip?: boolean) => {
  const { trackError } = useObservability();

  useEffect(() => {
    try {
      if (skip || getRailsEnv() !== 'production') {
        return;
      }

      // TODO: @pramodsum - update hotjar script to new version + use events
      // https://help.hotjar.com/hc/en-us/articles/360034216634-Hotjar-JavaScript-Functions-Reference#event-only-available-on-plus-and-business-plans
      hotjar('trigger', trigger);
    } catch (e: CatchError) {
      trackError('hotjar', e);
    }
    // eslint-disable-next-line
  }, [trigger, skip]);
};
